import { Component } from '@angular/core';
import { AnalyticsService } from '../services/analytics/analytics.service';
import { NGXLogger } from 'ngx-logger';
import { RoutingUtils } from 'src/app/routing/routing.utils';

@Component({
  selector: 'app-learn-more',
  templateUrl: './learn-more.component.html',
  styleUrls: ['./learn-more.component.scss'],
})
export class LearnMoreComponent {
  learnMoreLink = 'mailto:info@amilearn.ca';

  constructor(
    private analyticsService: AnalyticsService,
    private logger: NGXLogger,
    private routingUtils: RoutingUtils
  ) {}

  mailtoClick(): void {
    const element = this.analyticsService.elementNameForRoute(
      this.routingUtils.appRouteFromPath(window.location.pathname),
      'CTA Contact Sales'
    );
    this.logger.debug('element', element);

    this.analyticsService.pushEvent('contact_sales', {
      category: 'Button Click',
      action: 'Outbound Link',
      element,
    });
  }
}
